import sortableItem from 'ember-sortable/components/sortable-item';

export default sortableItem;
